import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sports-event',
  templateUrl: './sports-event.component.html',
  styleUrls: ['./sports-event.component.scss']
})
export class SportsEventComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
